import React from 'react';
import Configuration from '../../utils/configuration';

const Footer = (props) => {
	let social_networks = Configuration.social_networks;
	let data = props.data['site-properties'] && props.data['site-properties'].data;
	let contact = data && data.contact;
	return (
		<footer className="footer">
			<div className="footer__bottom-footer flex justify-between items-start">
				<div className="footer__content">
					<div className="footer__logo flex">
						<a href="http://www.asturiascongresos.com" title={`${Configuration.SITE_NAME}`}>
							<img
								src={`${Configuration.RESOURCES_URL}logo/logo-w.png`}
								alt={`${Configuration.SITE_NAME}`}
								title={`${Configuration.SITE_NAME}`}
							/>
						</a>
						<a href="https://www.gijon.es/" title={`${Configuration.SITE_NAME}`}>
							<img
								src={`${Configuration.RESOURCES_URL}logo/logo_ayto.png`}
								alt={`${Configuration.SITE_NAME}`}
								title={`${Configuration.SITE_NAME}`}
							/>
						</a>
					</div>
					<div className="footer__contact-items flex">
						<div className="footer__social-items flex">
							{social_networks.map((value) => {
								if (data && data[value.name]) {
									return (
										<a
											className="footer__social-item"
											href={data[value.name]}
											target="_blank"
											key={`social${value.name}`}
											rel="noopener noreferrer"
										>
											<i className={`fab fa-${value.icon}`} aria-hidden="true" />
										</a>
									);
								} else {
									return false;
								}
							})}
						</div>
						{contact && (
							<div className="footer__contact-item">
								<p className="footer__contact-title">{contact['name']}</p>
								<p className="footer__contact-content">
									{`${contact['address']['address']} - ${contact['address']['zip_code']}`}
								</p>
								<p className="footer__contact-content">{`${contact['address']['city']} ${contact[
									'address'
								]['region']}`}</p>
							</div>
						)}
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
